import React from 'react';

export const CardLable = ({ fieldLable, fieldValue, textColor, className, onClick, click, id }) => {

    return <div className="flex-col !flex-wrap justify-start items-start inline-flex w-24" onClick={() => onClick(click, id)} >
        <div className="text-zinc-500 text-sm font-normal whitespace-nowrap">{fieldLable}</div>
        <div style={{ color: textColor }} className={` ${className} text-sm sm:text-base font-semibold `}>{fieldValue}</div>
    </div>
}